var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountTier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    transform: "translate(4 1.69336)",
    d: "M8 9.9300003L9.0699997 10.74C9.46 11.03 9.9900007 10.66 9.8500004 10.19L9.4300003 8.8299999L10.63 7.8800001C11 7.5999999 10.79 7 10.31 7L8.9099998 7L8.4799995 5.6599998C8.3299999 5.1999998 7.6799998 5.1999998 7.5299997 5.6599998L7.0900002 7L5.6800003 7C5.2100005 7 5 7.6000004 5.3699999 7.8900003L6.5600004 8.8400002L6.1400003 10.2C6 10.67 6.5300002 11.04 6.9200001 10.75L8 9.9300003ZM3.3200002 20.559999L8 19L12.68 20.559999C13.33 20.779999 14 20.300001 14 19.610001L14 13.28C15.24 11.87 16 10.03 16 8C16 3.5799999 12.42 0 8 0C3.5799999 0 0 3.5799999 0 8C0 10.03 0.75999999 11.87 2 13.28L2 19.610001C2 20.290001 2.6700001 20.769999 3.3200002 20.559999ZM14 8C14 11.31 11.309999 14 8 14C4.6900001 14 2 11.31 2 8C2 4.6900001 4.6900001 2 8 2C11.309999 2 14 4.6900001 14 8Z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountTier);
export default __webpack_public_path__ + "static/media/AccountTier.64abcd56634a36a2e2e1e12469c801e0.svg";
export { ForwardRef as ReactComponent };